<ng-container *ngIf='!isLoading, else showLoading'>
  <div class="container">
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      dynamicHeight
      animationDuration='0ms'
      [selectedIndex]="selectedTab"
      (selectedIndexChange)='selectedTab = $event'
    >
      <mat-tab *ngFor='let tab of tabs' [label]='tab.label'>
        <ng-template matTabContent>
          <div class='pb--md'>
            <app-list-site-tours
              *ngIf="tab.id === 'app-list-site-tours'"
              [user]='user'
              [canEdit]='canEdit'
            ></app-list-site-tours>
            <app-list-hotspots
              *ngIf="tab.id === 'app-list-hotspots'"
              [user]='user'
              [canEdit]='canEdit'
            ></app-list-hotspots>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</ng-container>
<ng-template #showLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
